import React from 'react';
import AboutCopy from '../AboutCopy';

export default () => (
  <div className="modal-about">
    <AboutCopy />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Modal/About.js